// extracted by mini-css-extract-plugin
export default {"alert-info":"rgb(15, 98, 254)","message":"styles_message__RKZlb","MessageSlideDown":"styles_MessageSlideDown__JUyay","messageIcon":"styles_messageIcon__h-D0b"};